import { AsyncPipe } from '@angular/common';
import { Component, ViewChild, inject } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { CombinedFacettenUrlService } from '../../../services/facetten/combined-facetten-url.services';
import {
  BildungsBereich,
  BildungsbereichService
} from '../../../services/state/bildungsbereich.service';
import { ModalPopupComponent } from '../../modal/modal-popup/modal-popup.component';
@Component({
  selector: 'now-wbsuche-lib-bildungsbereichauswahl',
  standalone: true,
  imports: [AsyncPipe, ModalPopupComponent],
  styleUrls: ['bildungsbereichauswahl.component.scss'],
  templateUrl: './bildungsbereichauswahl.component.html'
})
export class BildungsbereichauswahlComponent {
  private readonly service = inject(BildungsbereichService);
  private readonly combinedFacettenUrlService = inject(CombinedFacettenUrlService);

  @ViewChild('bildungsbereichWechselnModal')
  private readonly modal!: ModalPopupComponent;

  public BildungsBereich = BildungsBereich;

  isChecked(bildungsbereich: BildungsBereich) {
    return this.service.bildungsbereich$.pipe(
      map((selectedBildungsbereich) => selectedBildungsbereich == bildungsbereich)
    );
  }

  async setBildungsbereich(event: Event, bildungsbereich: BildungsBereich) {
    const currentBildungsbereich = await firstValueFrom(this.service.bildungsbereich$);
    if (currentBildungsbereich != bildungsbereich) {
      const showModal = await firstValueFrom(
        this.combinedFacettenUrlService.combinedFacetteParameters$.pipe(
          map((parameter) => parameter.filter(({ ids }) => ids.length > 0).length > 0)
        )
      );

      if (showModal) {
        event.preventDefault();
        this.modal.openModal();
        this.modal.primaryButtonClick.subscribe(() => {
          this.service.setBildungsbereichAndResetFacetten(bildungsbereich);
        });
      } else {
        this.service.setBildungsbereichAndResetFacetten(bildungsbereich);
      }
    }
  }
}
